import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { DeleteDashboardNoteCommand, DeleteDashboardNoteCommandHandlerBase, DeleteDashboardNoteResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(DeleteDashboardNoteCommand)
@Injectable({ providedIn: 'root'})
export class DeleteDashboardNoteCommandHandler {
    private commandHandler: DeleteDashboardNoteCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new DeleteDashboardNoteCommandHandlerBase(http);
    }

    public async handleAsync(cmd: DeleteDashboardNoteCommand): Promise<DeleteDashboardNoteResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
